import { useState } from 'react'
import { Stack } from '@chakra-ui/react'
import { CreateComment } from 'components/UserSection/ProfileBlog/Comments/CreateComment'
import { CommentsForPost } from 'components/UserSection/ProfileBlog/Comments/CommentsForPost'
import { SUCCEEDED } from 'utils/constants'
import { COLORS } from 'utils/styles'

export const Comments = ({
  blogParent,
  comments,
  commentsOption,
  getCommentsStatus,
  postCommentsStatus,
  putCommentsStatus,
  selectedUser
}) => {
  const [editCommentData, setEditCommentData] = useState({})
  const parentData = blogParent[blogParent.length - 1]

  const handleMinHeight = () => {
    let wholeParent = document.querySelector('#MY_PROFILES-panel')
    const stickyHeader = document.querySelector('#stickyHeader' + blogParent[0]?.id)
    const minusToHeight = blogParent.length > 1 ? 21 : 46

    if (wholeParent && stickyHeader) {
      return wholeParent?.offsetHeight - stickyHeader?.offsetHeight - minusToHeight
    }

    return '100svh'
  }

  return (
    <Stack
      key={parentData?.comment_id ?? parentData?.id}
      direction="column"
      margin="-5px -10px -10px -10px"
      padding="10px 5px"
      minHeight={handleMinHeight()}
      background={COLORS.darkGray}
    >
      {
        getCommentsStatus === SUCCEEDED || comments.length
          ? (
            <CreateComment
              selectedUser={selectedUser}
              blogParent={blogParent}
              getCommentsStatus={getCommentsStatus}
              type={commentsOption.type}
              postCommentsStatus={postCommentsStatus}
              putCommentsStatus={putCommentsStatus}
              editCommentData={editCommentData}
              setEditCommentData={setEditCommentData}
            />
          ) : ''
      }

      <CommentsForPost
        blogParent={blogParent}
        comments={comments}
        commentsOption={commentsOption}
        getCommentsStatus={getCommentsStatus}
        selectedUser={selectedUser}
        setEditCommentData={setEditCommentData}
      />
    </Stack>
  )
}
